
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import Dialog from '@/components/Dialog.vue';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';
import Swal from 'sweetalert2';
import imageConvert from '@/utils/image';

const { otherPoint, swapInPoint } = api;
const { requiredRule, maxLengthRule } = { ...ruleMixin.methods };

@Component({
  components: {
    Dialog,
  },
  mixins: [ruleMixin],
})
export default class OtherPointEdit extends Vue {
  private id!: string;

  public loading = false;

  public valid = true;

  public iconPic = '';

  public swapInItems: Array<{ text: string; value: string }> = [];

  public form = {
    pointName: '',
    iconUrl: '',
    bindingInstructionsUrl: '',
    unbindingInstructionsUrl: '',
    officialUrl: '',
    itemId: undefined,
    sort: 0,
    maxRedeemPercentage: null,
  };

  public rules = {
    pointName: [
      ...requiredRule('合作商店名稱'),
      ...maxLengthRule('合作商店名稱', 20),
    ],
    bindingInstructionsUrl: [...requiredRule('綁定說明連結')],
    unbindingInstructionsUrl: [...requiredRule('刪除說明連結')],
    officialUrl: [...requiredRule('宣傳連結')],
    pic: [this.validatePic((vm: OtherPointEdit) => vm.iconPic)],
    sort: [...this.getNumberRule('排序')],
  };

  private validatePic(func: (vm: OtherPointEdit) => any) {
    return (v: any) => {
      const p = func(this);
      return !!v || !!p || '請上傳合作商店圖片';
    };
  }

  private getNumberRule(column: string) {
    return [
      (v: any) => /^\d+(\.\d+)?$/.test(v) || `${column} 必須是數字`,
      (v: any) => v !== '' || `${column} 為必填`,
    ];
  }

  public async save() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      const submitForm = {
        ...this.form,
        iconUrl: await imageConvert(this.form.iconUrl as any),
      };
      const { status } = await otherPoint.edit(this.id, submitForm);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private async SetSwapInItems() {
    const {
      data: { data },
    } = (await swapInPoint.itemList({ pageNo: 1 })) || {};
    if (!!data) {
      const categories: Array<{ text: string; value: string }> = data.map(
        (v: any) => ({ text: v.itemName, value: v.itemId }),
      );
      this.swapInItems = [{ text: '無', value: '' }, ...categories];
    }
  }

  public async close() {
    await this.$router.back();
  }

  public handleClearImage() {
    this.form.iconUrl = '';
    this.iconPic = '';
  }

  public changeImage(event: any) {
    if (event) {
      this.form.iconUrl = event;
      this.iconPic = URL.createObjectURL(event);
    }
  }

  private async setForm(id: string, form: any) {
    this.id = id;
    this.form = { ...form };
    this.iconPic = this.form.iconUrl;
    await this.SetSwapInItems();
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: OtherPointEdit) => void) | boolean) => void,
  ) {
    const { data } = await otherPoint.get(to.params.id);
    await next(async (vm) => {
      vm.setForm(to.params.id, data);
    });
  }
}
